import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-7fa9ba70-b1a8-45ed-af73-1282db771570-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-8156cb24-fcd8-4033-b960-4cd1af3026c5-__Layer_2_1_\"><g id=\"ec-466b3ef8-eb23-4ea7-afc7-191a12ca5cfd-__Layer_1-2\"><g id=\"ec-50c1e19d-b8a5-4b02-8880-5ab450120df5-__format_underlined\"><path d=\"m12.2 12h1.9v22.1c0 12.1 9.8 21.9 21.9 21.9s21.9-9.8 21.9-21.9v-22.1h1.9c1.7 0 3-1.3 3-3s-1.3-3-3-3h-9.8c-1.7 0-3 1.3-3 3s1.3 3 3 3h1.9v22.1c0 8.8-7.1 15.9-15.9 15.9s-15.9-7.1-15.9-15.9v-22.1h1.9c1.7 0 3-1.3 3-3s-1.3-3-3-3h-9.8c-1.7 0-3 1.3-3 3s1.4 3 3 3z\"></path><path d=\"m60 60h-48c-1.7 0-3 1.3-3 3s1.3 3 3 3h48c1.7 0 3-1.3 3-3s-1.3-3-3-3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }